<template>
  <div class="flex-grid">
    <Loading :is-progress="isProgress" />
    <div class="col1">
      <div class="main_heading">
        <h3>Create / Update Template</h3>
        <a
          class="button_create"
          href="/fasciawiseTemplates/"
        >Manage Template</a>
      </div>
      <!-- use the modal component, pass in the prop -->
      <Modal
        v-if="showModal"
        @close="closeSpot()"
      >
        <h3 slot="header">
          Add Spot
        </h3>
        <div slot="body">
          <label for="roleName">
            <b>Image Link</b>
          </label>
          <input
            v-model="spotImageLink"
            type="text"
            placeholder="Enter Image Link"
            name="Prefix"
          >
          <label for="roleName">
            <b>URL</b>
          </label>
          <input
            v-model="spotURL"
            type="text"
            placeholder="Enter URL"
            name="Prefix"
          >
        </div>
        <div slot="footer">
          <button
            class="modal-default-button"
            @click="addSpot()"
          >
            {{ spotBtnName }}
          </button>
          <button
            class="modal-default-button close"
            @click="closeSpot()"
          >
            Close
          </button>
        </div>
      </Modal>
      <div class="form-fields">
        <label for="roleName">
          <b>Select fascia</b>
        </label>
        <select
          v-model="fasciaGroup"
          :disabled="isDisabled"
        >
          <option value>
            Select Fascia
          </option>
          <option
            v-for="(fascia, key) in fasciasList"
            :key="key"
            :value="fascia._id"
          >
            {{ fascia.fasica_name }}
          </option>
        </select>
      </div>
      <div class="form-fields">
        <label for="roleName">
          <b>Select Category</b>
        </label>
        <select
          v-model="category"
          :disabled="isDisabled"
          @change="checkExist()"
        >
          <option value>
            Select Category
          </option>
          <option
            v-for="(categorys, key) in categoryList"
            :key="key"
            :value="categorys._id"
          >
            {{ categorys.categoryName }}
          </option>
        </select>
      </div>
      <Tabs
        :tabs="tabs"
        :current-tab="currentTab"
        @onClick="handleClick"
      />
      <div class="content">
        <div v-if="currentTab === 'tab1'">
          <div class="form-fields">
            <label for="roleName">
              <b>Header Html</b>
            </label>
            <textarea
              v-model="headerHTML"
              rows="10"
              cols="80"
            />
          </div>
        </div>
        <div v-if="currentTab === 'tab2'">
          <div class="usp-section">
            <div class="form-fields">
              <label for="roleName">
                <b>Select USP Type</b>
              </label>
              <select
                v-model="uspCat"
                @change="uspChange()"
              >
                <option value>
                  Select USP Type
                </option>
                <option value="image">
                  Image and Link
                </option>
                <option value="text">
                  Text and Link
                </option>
                <option value="imageText">
                  Image with Text and Link
                </option>
              </select>
            </div>
            <div
              v-show="isUSP"
              class="form-fields"
            >
              <div v-show="isImgLink || isImgTextLink">
                <label for="roleName">
                  <b>Image Link</b>
                </label>
                <input
                  v-model="uspImageLink"
                  type="text"
                  placeholder="Enter Image Link"
                  name="Prefix"
                >
              </div>
              <div v-show="isTextLink || isImgTextLink">
                <label for="roleName">
                  <b>Text to Display</b>
                </label>
                <input
                  v-model="uspText"
                  type="text"
                  placeholder="Enter Text"
                  name="Prefix"
                >
                <label for="roleName">
                  <b>Text Color Code</b>
                </label>
                <input
                  v-model="uspTextColor"
                  type="text"
                  placeholder="Enter Text Color Code"
                  name="Prefix"
                >
              </div>
              <div v-show="isTextLink">
                <label for="roleName">
                  <b>Background Color Code</b>
                </label>
                <input
                  v-model="uspBackColor"
                  type="text"
                  placeholder="Enter Background Color Code"
                  name="Prefix"
                >
              </div>
              <label for="roleName">
                <b>URL</b>
              </label>
              <input
                v-model="uspURL"
                type="text"
                placeholder="Enter URL"
                name="Prefix"
              >
            </div>
          </div>
        </div>
        <div v-if="currentTab === 'tab3'">
          <div
            v-if="bottomSpots"
            class="top-spots"
          >
            <label for="roleName">
              <b>Top Spots</b>
            </label>
            <button
              id="show-modal"
              class="addSpot"
              @click="createSpot('top'); "
            >
              Add Spot
            </button>
            <Draggable
              v-model="topSpots"
              class="spot_slots"
              @end="onEnd()"
            >
              <div
                v-for="(spot, index) in topSpots"
                :key="spot.link"
                class="list-complete-item"
              >
                <div>
                  <img :src="spot.image_url">
                </div>
                <div>
                  <button @click="editSpot('top', index)">
                    Edit
                  </button>
                  <button @click="deleteSpot('top', index)">
                    Delete
                  </button>
                </div>
              </div>
            </Draggable>
          </div>
        </div>
        <div v-if="currentTab === 'tab4'">
          <div
            v-if="bottomSpots"
            class="bottom-spots"
          >
            <label for="roleName">
              <b>Bottom Spots</b>
            </label>
            <button
              id="show-modal"
              class="addSpot"
              @click="createSpot('bottom')"
            >
              Add Spot
            </button>
            <Draggable
              v-model="bottomSpots"
              class="spot_slots"
              @end="onEnd()"
            >
              <div
                v-for="(spot, index) in bottomSpots"
                :key="spot.link"
                class="list-complete-item"
              >
                <div>
                  <img :src="spot.image_url">
                </div>
                <div>
                  <button @click="editSpot('bottom', index)">
                    Edit
                  </button>
                  <button @click="deleteSpot('bottom', index)">
                    Delete
                  </button>
                </div>
              </div>
            </Draggable>
          </div>
        </div>
        <div v-if="currentTab === 'tab5'">
          <div class="form-fields">
            <label for="roleName">
              <b>Custom Template Html</b>
            </label>
            <textarea
              v-model="customTemplateContent"
              rows="10"
              cols="80"
            />
            <!-- <label for="roleName"><b>Select Positon to Display</b></label>
        <select v-model = "customTemplatePosition">
          <option value="">Select Fascia</option>
          <option value="">After Header</option>
          <option value="">After USP</option>
          <option value="">After Top Spots</option>
          <option value="">After Bottom Spots</option>
          <option value="">After Footer</option>
            </select>-->
          </div>
        </div>
        <div v-if="currentTab === 'tab6'">
          <div class="form-fields">
            <label for="roleName">
              <b>Footer Html</b>
            </label>
            <textarea
              v-model="footerHTML"
              rows="10"
              cols="80"
            />
          </div>
        </div>
      </div>
      <a
        class="button_create"
        @click="createfasciaTemplate()"
      >{{ action }}</a>
    </div>
    <div class="col2">
      <div
        class="main_heading"
        style="background-color: #f4a460; text-align: center; margin-left: 1rem;"
      >
        <h3 style="line-height: 50px;">
          Output
        </h3>
      </div>
      <div
        class="html-content"
        v-html="htmlContent"
      />
    </div>
  </div>
</template>

<script>
import Tabs from 'vue-tabs-with-active-line';
import Draggable from 'vuedraggable';
import Modal from '@/components/Modal.vue';
import Loading from '@/components/loading.vue';

export default {
  name: 'CreateFT',
  components: {
    Tabs,
    Draggable,
    Modal,
    Loading,
  },
  data() {
    return {
      showModal: false,
      isProgress: true,
      bottomSpots: [],
      topSpots: [],
      isUpdate: false,
      isDisabled: false,
      isUSP: false,
      isImgLink: false,
      isImgTextLink: false,
      isTextLink: false,
      spotImageLink: '',
      spotURL: '',
      spotBtnName: 'Create',
      action: 'Create',
      fasciasList: [],
      htmlContent: '',
      categoryList: [],
      category: '',
      uspText: '',
      uspTextColor: '',
      uspBackColor: '',
      fasciaGroup: '',
      footerHTML: '',
      headerHTML: '',
      customTemplateContent: '',
      customTemplateHTML: '',
      uspHTML: '',
      uspImageLink: '',
      uspURL: '',
      uspCat: '',
      selectedSpot: '',
      btmSpotContent: '',
      topSpotsContent: '',
      selectedTopBottom: '',
      tabs: [
        { title: 'Header', value: 'tab1' },
        { title: 'USP', value: 'tab2' },
        { title: 'Top Spots', value: 'tab3' },
        { title: 'Bottom Spots', value: 'tab4' },
        { title: 'Custom Template', value: 'tab5' },
        { title: 'Footer', value: 'tab6' },
      ],
      currentTab: 'tab1',
    };
  },
  watch: {
    headerHTML() {
      this.updateContent();
    },
    footerHTML() {
      this.updateContent();
    },
    uspImageLink() {
      this.updateUSPContent();
    },
    uspURL() {
      this.updateUSPContent();
    },
    uspText() {
      this.updateUSPContent();
    },
    uspTextColor() {
      this.updateUSPContent();
    },
    uspBackColor() {
      this.updateUSPContent();
    },
    customTemplateContent() {
      this.updateCustomTemplateContent();
    },
  },
  created() {
    this.$eventHub.$on('userData', this.getCurrentUser);
  },
  beforeDestroy() {
    this.$eventHub.$off('userData');
  },
  mounted() {
    this.getCurrentUser();
    const getfascias = fetch('/api/fascias/all', {
      credentials: 'same-origin',
    });
    getfascias
      .then(data => data.json())
      .then((data) => {
        this.fasciasList = data;
      });
    const getCategories = fetch('/api/categorylist/all', {
      credentials: 'same-origin',
    });
    getCategories
      .then(data => data.json())
      .then((data) => {
        this.categoryList = data;
      });
    if (this.$route.query.id) {
      this.action = 'Update';
      this.isUpdate = true;
      this.isDisabled = true;
      const getData = fetch(`/api/fasciaTemplates/${this.$route.query.id}`, {
        credentials: 'same-origin',
      });
      getData
        .then(data => data.json())
        .then((data) => {
          this.category = data.category;
          this.fasciaGroup = data.fascia_id;
          this.footerHTML = data.footer_html;
          this.headerHTML = data.header_html;
          if (data.usp_url !== 'undefined') {
            this.uspHTML = data.usp_html;
            this.uspURL = data.usp_url;
          }
          if (data.top_spots_html !== 'undefined') {
            this.topSpots = data.top_spots;
            this.topSpotsContent = data.top_spots_html;
          }
          if (data.bottom_spots_html !== 'undefined') {
            this.bottomSpots = data.bottom_spots;
            this.btmSpotContent = data.bottom_spots_html;
          }
          if (data.custom_template_html !== 'undefined') {
            this.customTemplateContent = data.custom_template_content || '';
            this.customTemplateHTML = data.custom_template_html;
          }
          if (data.usp_category === 'image') {
            this.uspCat = data.usp_category;
            this.isUSP = true;
            this.isImgLink = true;
            this.uspImageLink = data.usp_image_link;
          } else if (data.usp_category === 'text') {
            this.uspCat = data.usp_category;
            this.isUSP = true;
            this.isTextLink = true;
            this.uspText = data.usp_text;
            this.uspTextColor = data.usp_text_color;
            this.uspBackColor = data.usp_back_color;
          } else if (data.usp_category === 'imageText') {
            this.uspCat = data.usp_category;
            this.isUSP = true;
            this.isImgTextLink = true;
            this.uspImageLink = data.usp_image_link;
            this.uspTextColor = data.usp_text_color;
            this.uspText = data.usp_text;
          }
        });
    }
    this.isProgress = false;
  },
  methods: {
    getCurrentUser(userData) {
      // you don't have to pass it again from the listener.
      if (userData) {
        if (userData.role_id === 2) {
          this.tabs = [
            { title: 'USP', value: 'tab2' },
            { title: 'Top Spots', value: 'tab3' },
            { title: 'Bottom Spots', value: 'tab4' },
            { title: 'Custom Template', value: 'tab5' },
          ];
          this.currentTab = 'tab2';
        }
      }
    },
    checkExist() {
      if (this.fasciaGroup === '') {
        this.$toasted.error('Please Select Fascia', { duration: 3000 });
        this.category = '';
        return true;
      }
      this.isProgress = true;
      const template = fetch(
        `/api/fasciaTemplatesByfacia/${this.fasciaGroup}/${this.category}`,
        { credentials: 'same-origin' },
      );
      template
        .then(data => data.json())
        .then((data) => {
          this.$router.push({
            path: '/createfasciawiseTemplate/',
            query: { id: `${data[0]._id}` },
          });
        });
      this.isProgress = false;
      return true;
    },
    onEnd() {
      this.bindSpots();
    },
    handleClick(newTab) {
      this.currentTab = newTab;
    },
    uspChange() {
      if (`${this.uspCat}` === 'image') {
        this.isUSP = true;
        this.isImgLink = true;
        this.isTextLink = false;
        this.isImgTextLink = false;
      } else if (`${this.uspCat}` === 'text') {
        this.isUSP = true;
        this.isTextLink = true;
        this.isImgLink = false;
        this.isImgTextLink = false;
      } else if (`${this.uspCat}` === 'imageText') {
        this.isUSP = true;
        this.isImgTextLink = true;
        this.isImgLink = false;
        this.isTextLink = false;
      } else {
        this.isUSP = false;
        this.isImgLink = false;
        this.isTextLink = false;
        this.isImgTextLink = false;
      }
      this.uspImageLink = '';
      this.uspURL = '';
      this.uspText = '';
      this.uspTextColor = '';
      this.uspBackColor = '';
    },
    updateUSPContent() {
      if (`${this.uspCat}` === 'image') {
        let uspContent = '<tr><td><table border="0" cellpadding="0" cellspacing="0" width="100%"><tbody><tr>';
        uspContent += `<td align="center" width="100%"><a href="${this.uspURL}" style="font-size:0; display:block;"><img border="0" `;
        uspContent += `src="${this.uspImageLink}" style="display:block" width="100%"> </a></td>`;
        uspContent += '</tr></tbody></table></td></tr>';
        this.uspHTML = uspContent;
      } else if (`${this.uspCat}` === 'text') {
        let uspContent = `<tr><td id="delivery" style="background-color:${this.uspBackColor};"><table border="0" cellpadding="0" cellspacing="0" style="width:100%;" width="100%">`;
        uspContent += `<tbody><tr><td align="center" width="100%"><a href="${this.uspURL}" style="text-decoration: none;color:${this.uspTextColor};padding: 10px 0;display: block;">${this.uspText}</a></td>`;
        uspContent += '</tr></tbody></table></td></tr>';
        this.uspHTML = uspContent;
      } else if (`${this.uspCat}` === 'imageText') {
        let uspContent = '<tr><td id="delivery">';
        uspContent += `<table border="0" cellpadding="0" cellspacing="0" style="width:100%;background-image: url(${this.uspImageLink})" width="100%">`;
        uspContent += `<tbody><tr><td align="center" style="padding: 10px 0 !important;" width="100%"><a href="${this.uspURL}" style="text-decoration: none;color:${this.uspTextColor};">${this.uspText}</a></td>`;
        uspContent += '</tr></tbody></table></td></tr>';
        this.uspHTML = uspContent;
      }
      this.updateContent();
    },
    createfasciaTemplate() {
      if (this.fasciaGroup === '') {
        this.$toasted.error('Please Select Fascia', { duration: 3000 });
        return true;
      }
      if (this.category === '') {
        this.$toasted.error('Please Select Category', { duration: 3000 });
        return true;
      }
      if (this.headerHTML === '') {
        this.$toasted.error('Please Enter Header HTML', { duration: 3000 });
        return true;
      }
      if (this.footerHTML === '') {
        this.$toasted.error('Please Enter Footer HTML', { duration: 3000 });
        return true;
      }
      let url = '/api/createfasciaTemplate';
      const data = {
        fascia: this.fasciaGroup,
        header: this.headerHTML,
        footer: this.footerHTML,
        category: this.category,
        topSpots: this.topSpots,
        topSpotsContent: this.topSpotsContent,
        bottomSpots: this.bottomSpots,
        btmSpotContent: this.btmSpotContent,
        customTemplateContent: this.customTemplateContent,
        customTemplateHTML: this.customTemplateHTML,
      };
      if (this.customTemplateContent === '') {
        data.customTemplateHTML = '';
      }
      if (this.uspCat === '') {
        data.uspText = '';
        data.uspTextColor = '';
        data.uspBackColor = '';
        data.uspURL = '';
        data.uspCat = '';
        data.uspImageLink = '';
        data.usp = '';
      } else if (this.uspCat === 'image') {
        data.uspCat = this.uspCat;
        data.uspURL = this.uspURL;
        data.usp = this.uspHTML;
        data.uspImageLink = this.uspImageLink;
        data.uspText = '';
        data.uspTextColor = '';
        data.uspBackColor = '';
      } else if (this.uspCat === 'text') {
        data.uspCat = this.uspCat;
        data.uspURL = this.uspURL;
        data.usp = this.uspHTML;
        data.uspText = this.uspText;
        data.uspTextColor = this.uspTextColor;
        data.uspBackColor = this.uspBackColor;
        data.uspImageLink = '';
      } else if (this.uspCat === 'imageText') {
        data.uspCat = this.uspCat;
        data.uspURL = this.uspURL;
        data.usp = this.uspHTML;
        data.uspImageLink = this.uspImageLink;
        data.uspText = this.uspText;
        data.uspTextColor = this.uspTextColor;
        data.uspBackColor = '';
      }
      let currentMethod = 'POST';
      if (this.isUpdate) {
        currentMethod = 'PUT';
        url = `/api/createfasciaTemplate/${this.$route.query.id}`;
      }
      fetch(url, {
        method: currentMethod, // or 'PUT'
        body: JSON.stringify(data), // data can be `string` or {object}!
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(res => res.json())
        .catch(error => this.$toasted.error(
          `Something Went Wrong. Please try again - ${error}`,
          { duration: 3000 },
        ))
        .then(response => this.$toasted.success(response.message, { duration: 3000 }))
        .then(
          setTimeout(
            () => this.$router.push({ name: 'fasciawiseTemplates' }),
            3000,
          ),
        );
      return true;
    },
    createSpot(position) {
      this.selectedTopBottom = position;
      this.showModal = true;
      this.spotBtnName = 'Create';
    },
    addSpot() {
      if (this.spotImageLink === '') {
        this.$toasted.error('Please Enter Image Link', { duration: 3000 });
        return true;
      }
      if (this.spotURL === '') {
        this.$toasted.error('Please Enter URL', { duration: 3000 });
        return true;
      }
      if (this.spotBtnName === 'Create') {
        const newSpot = {
          image_url: this.spotImageLink,
          link: this.spotURL,
        };
        if (this.selectedTopBottom === 'top') {
          this.topSpots.push(newSpot);
        } else if (this.selectedTopBottom === 'bottom') {
          this.bottomSpots.push(newSpot);
        }
      } else if (this.spotBtnName === 'Update') {
        if (this.selectedTopBottom === 'top') {
          this.topSpots[this.selectedSpot].image_url = this.spotImageLink;
          this.topSpots[this.selectedSpot].link = this.spotURL;
        } else if (this.selectedTopBottom === 'bottom') {
          this.bottomSpots[this.selectedSpot].image_url = this.spotImageLink;
          this.bottomSpots[this.selectedSpot].link = this.spotURL;
        }
      }
      this.bindSpots();
      this.spotImageLink = '';
      this.spotURL = '';
      this.selectedSpot = '';
      this.showModal = false;
      return true;
    },
    closeSpot() {
      this.spotImageLink = '';
      this.spotURL = '';
      this.showModal = false;
    },
    editSpot(position, spot) {
      this.selectedSpot = spot;
      this.selectedTopBottom = position;
      this.spotBtnName = 'Update';
      if (position === 'top') {
        this.spotImageLink = this.topSpots[spot].image_url;
        this.spotURL = this.topSpots[spot].link;
      } else if (position === 'bottom') {
        this.spotImageLink = this.bottomSpots[spot].image_url;
        this.spotURL = this.bottomSpots[spot].link;
      }
      this.showModal = true;
    },
    deleteSpot(position, spot) {
      if (position === 'top') {
        this.topSpots.splice(spot, 1);
      } else if (position === 'bottom') {
        this.bottomSpots.splice(spot, 1);
      }
      this.bindSpots();
    },
    bindSpots() {
      this.btmSpotContent = '';
      this.topSpotsContent = '';
      if (this.bottomSpots.length >= 1) {
        this.bottomSpots.forEach((spot) => {
          let spotContent = '<tr><td><table width="100%" border="0" cellspacing="0" cellpadding="0"><tbody><tr><td align="center" width="100%">';
          spotContent += `<a href="${spot.link}" style="font-size:0; display:block;">`;
          spotContent += `<img style="display:block" border="0" width="100%" src="${spot.image_url}">`;
          spotContent += '</a></td></tr></tbody></table></td></tr>';
          this.btmSpotContent = this.btmSpotContent + spotContent;
        });
      }
      if (this.topSpots.length >= 1) {
        this.topSpots.forEach((spot) => {
          let spotContent = '<tr><td><table width="100%" border="0" cellspacing="0" cellpadding="0"><tbody><tr><td align="center" width="100%">';
          spotContent += `<a href="${spot.link}" style="font-size:0; display:block;">`;
          spotContent += `<img style="display:block" border="0" width="100%" src="${spot.image_url}">`;
          spotContent += '</a></td></tr></tbody></table></td></tr>';
          this.topSpotsContent = this.topSpotsContent + spotContent;
        });
      }
      this.updateContent();
    },
    updateCustomTemplateContent() {
      let customTemplateHTML = '<tr><td><table border="0" cellpadding="0" cellspacing="0" width="100%"><tbody><tr>';
      customTemplateHTML += `${this.customTemplateContent}`;
      customTemplateHTML += '</tr></tbody></table></td></tr>';
      this.customTemplateHTML = customTemplateHTML;
      this.updateContent();
    },
    updateContent() {
      this.htmlContent = this.headerHTML
        + this.uspHTML
        + this.topSpotsContent
        + this.btmSpotContent
        + this.customTemplateHTML
        + this.footerHTML;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.flex-grid {
  display: flex;
  justify-content: space-between;
}

.col1 {
  width: 50%;
}

.col2 {
  width: 50%;
}

textarea {
  display: block;
}

/* Tabs CSS Start Here */
.tabs {
  background-color: #337ab7;
  margin-right: 0.5rem;
}

.col1 >>> .tabs__item {
  display: inline-block;
  margin: 0 -2px;
  padding: 10px;
  padding-bottom: 8px;
  font-size: 16px;
  letter-spacing: 0.8px;
  color: #fff;
  text-decoration: none;
  border: none;
  background-color: transparent;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  transition: all 0.25s;
}

.col1 >>> .tabs__item:focus {
  outline: none;
}

.col1 >>> .tabs__item_active {
  background-color: #25435d;
}

.col1 >>> .tabs__item:first-child {
  margin-left: 0;
}

.col1 >>> .tabs__active-line {
  position: absolute;
  left: 0;
  height: 2px;
  background-color: blue;
  transition: transform 0.4s ease, width 0.4s ease;
  display: none;
}

.col1 >>> .content {
  margin-top: 1rem;
}

.list-complete-item {
  cursor: move;
  display: flex;
  flex-direction: row;
}

.col1 >>> .list-complete-item {
  padding: 4px;
  margin-top: 4px;
  border: solid 1px;
  transition: all 1s;
}

.col1 >>> .list-complete-enter,
.list-complete-leave-active {
  opacity: 0;
}

.col1 >>> .addSpot {
  background-color: #337ab7;
  border: none;
  color: white;
  padding: 8px 10px;
  text-align: center;
  text-decoration: none;
  font-size: 16px;
  margin: 4px 15px;
  float: right;
}

input,
select,
textarea {
  width: 100%;
}

.list-complete-item img {
  width: 100%;
}

.list-complete-item button {
  background-color: #5bc0de;
  border: none;
  color: white;
  padding: 8px 10px;
  text-align: center;
}

.list-complete-item button + button {
  background-color: #f0ad4e;
}

.spot_slots {
  width: 75%;
}

.list-complete-item > div {
  flex-basis: 50%;
  text-align: center;
}
</style>
